{
  "button": {
    "loading": "Loading...",
    "upload": "Upload Workout File"
  },
  "input": {
    "ariaLabel": "Upload workout file"
  },
  "badge": {
    "ariaLabel": "File format: {{format}}"
  },
  "status": {
    "converting": "Converting {{fileName}}...",
    "progressLabel": "Conversion progress: {{progress}}%",
    "remaining": "{{time}} remaining",
    "loaded": "Loaded: {{fileName}}"
  },
  "dropzone": {
    "title": "Drop a FIT, TCX, ZWO, GCN, or KRD file",
    "hint": "Or click below to choose one from your device."
  },
  "warnings": {
    "title": "Imported with warnings",
    "description": "Some parts of this file could not be imported exactly. Review the workout before you use it."
  },
  "noActiveAthlete": {
    "title": "No active athlete",
    "description": "Select or create an athlete before importing a file."
  }
}
